import React from 'react';
import useUpdatePatientProfileNotesMutation from 'App/hooks/useUpdatePatientProfileNotesMutation';
import styled from '@emotion/styled';
import ToggleSwitch from 'App/components/ToggleSwitch';

const CellStyle = styled('div')`
    width: 100%;
    text-align: center;

    button {
        background: transparent;
        padding: 0;
        margin: 0;
        border: none;
    }
`;

const ImportantCell = (value, noteObject, patientId, isFormOpen) => {
    const { uuid, note } = noteObject;
    const updateMutation = useUpdatePatientProfileNotesMutation(patientId);
    return (
        <CellStyle>
            <ToggleSwitch
                aria-label="Important"
                checked={!!value}
                disabled={isFormOpen}
                onChange={() => {
                    updateMutation.mutateAsync({ uuid, note, important: !value });
                }}
            />
        </CellStyle>
    );
};

export default ImportantCell;
